import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../styles/UserList.css";
import DefaultEmployeeProfile from "../images/DefaultEmployeeProfile.svg";
import deleteIcon from "../images/deleteIcon.svg";
import editIcon from "../images/editIcon.svg";
import generateInvoice from "../images/generateInvoice.svg";
import dustbin from "../images/dustbin.svg";
import {
  deniedActionClass,
  usePermissionGuard,
} from "../hooks/usePermissionGuard";
import { PERMISSIONS } from "../utils/rbac";

const ConfirmDeleteModal = ({ email, onDeleteUser, onClose, type }) => {
  return (
    <div className="custom-modal">
      <div className="modal-content">
        <div className="left-container">
          <img src={dustbin} alt="Dustbin" className="dustbin-image" />
        </div>
        <div className="right-container" style={{backgroundColor:"transparent"}}>
          <p className="delete-warning-p">{`Are you sure you want to delete this ${type}?`}</p>
          <div className="button-container">
            <button
              className="delete-button"
              onClick={() => {
                onDeleteUser(email);
                onClose();
              }}
            >
              Delete
            </button>
            <button className="cancel-button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function PaySlipMetaList({ users, onDeleteUser, pageSize, currentPage, type }) {
  const startIndex = (currentPage - 1) * pageSize + 1;
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  const { guardAction, PermissionDialog, isAllowed } = usePermissionGuard();
  const canDeleteMetadata = isAllowed(PERMISSIONS.MANAGE_METADATA);

  const handleDeleteUser = (ID, type) => {
    guardAction(PERMISSIONS.MANAGE_METADATA, `delete ${type}`, () => {
      setUserToDelete(ID);
      setShowModal(true);
    });
  };

  const confirmDelete = () => {
    onDeleteUser(userToDelete, type);
    setShowModal(false);
  };

  const cancelDelete = () => {
    setUserToDelete(null);
    setShowModal(false);
  };

  const handleEditClick = (userId) => {
    setSelectedUserId(userId);
  };
  const handleOnClick = (email) => {
    // Perform any necessary actions

    // Navigate to the /userProfile route with email as a parameter

  };
  const navigate = useNavigate();

  return (
    <div className="user-list user-list-margin">
      <PermissionDialog />
      {showModal && (
        <ConfirmDeleteModal
          email={userToDelete}
          onDeleteUser={confirmDelete}
          onClose={cancelDelete}
          type={type}
        />
      )}
      <table className="user-table">
        <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.ID}>
              <td
                className=""
              >
                  #{user.ID}
              </td>
              <td onClick={() => handleOnClick(user.NAME)}>   
                  {user.NAME.charAt(0).toUpperCase() + user.NAME.slice(1)}
              </td>
              <td>
                <img
                  src={deleteIcon}
                  alt="Delete Icon"
                  className={`delete-icon paylist-icon admin-panel-icon ${deniedActionClass(canDeleteMetadata)}`}
                  onClick={() => handleDeleteUser(user.ID, type)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PaySlipMetaList;
